import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import Collapse from "../../components/atoms/colapso";
import Footer from "../../components/organisms/footer";
import NavBar from "../../components/organisms/navbar";
import { FaMapMarkerAlt } from 'react-icons/fa';
//import useAuthenticate from "../../hooks/useAuthenticate";
import {
  Container,
  Content,
  H3,
  H5,
  Location,
  P,
  QRCodeImg,
  Span,
  Title,
  TournamentActions,
  TournamentBanner,
  TournamentContainer,
  TournamentContainerBanner,
  TournamentContent,
  TournamentDescription,
  TournamentEnrollmentLink,
  TournamentEnrollmentLinkEndpage,
  TournamentLink,
  EditalContainer,
  EditalContent,
  EditalTitle
} from "./styles";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../services/api";
import Swal from "sweetalert2";
import tabelaPeso from "../../assets/images/tournaments/circuito-fajje-coari-de-jiu-jitsu-coari-am/tabela-circuito-fajje-coari-de-jiu-jitsu-coari-am.jpg";
import medalhas from "../../assets/images/tournaments/circuito-fajje-coari-de-jiu-jitsu-coari-am/circuito-fajje-coari-de-jiu-jitsu-coari-am-medalhas.jpeg";

//Patrocinio
import torneio from "../../assets/images/sponsors/torneio-facil.png";
import prefeituraCoari from "../../assets/images/sponsors/prefeitura-coari.png";
import secretariaCoari from "../../assets/images/sponsors/secretaria-esporte-coari.png";

//Apoio
import { SponsorContainer, SponsorList } from "src/components/atoms/sponsor-area/styles";
import SponsorButton from "src/components/atoms/sponsor-area";
import useAuthenticate from "../../hooks/useAuthenticate";

const sponsors: any[] = [];

const support = [
  { img: prefeituraCoari, url: "" },
  { img: secretariaCoari, url: "" },
  { img: torneio, url: "http://www.torneiofacil.com" },
];


const cacheBuster = `?cacheBuster=${new Date().getTime()}`
const dataEvento = "14 de março de 2026"
const horaEvento = "9:00h da manhã"
const tituloEvento = "Circuito FAJJE COARI - GI & NO GI 2026"
const localEvento = "Ginásio Poliesportivo Geraldo Granjeiro"
const endereçoEvento = "269, R. Cap. Silva, 175 - Tauá Mirim, Coari - AM, 69460-000"
const dataDeEncerramentoIncricao = "06/MAR/2026"
const horaDeEncerramentoIncricao = "23h:59"

const dataDeEncerramentoCorrecao = "08/MAR/2026"
const horaDeEncerramentoCorrecao = "23h:59min"

const valorInscricaoGi = "50,00 (cinquenta reais)"
const valorInscricaoNogi = "50,00 (cinquenta reais)"

const dataDeDivulgacaoChaves = "13/MAR/2026"
const horaDeDivulgacaoChaves = "23h:59min"

const instituicaoBancaria = ""
const tipoDeChavePix = "Celular"
const ChavePix = "92994663061"
const BeneficiarioDaChavePix = "LN EVENTOS"

const dataDeDivulgacaoCronograma = " "
const horaDeDivulgacaoCCronograma = " "

const contatoWhatsApp = "+55 92 99466-3061 - Luis Neto"
const contatoWhatsAppTorneio = "+55 (11) 94456-3515"

const slugGI = "circuito-fajje-coari-de-jiu-jitsu-coari-am-gi";
const slugNOGI = "circuito-fajje-coari-de-jiu-jitsu-coari-am-nogi";
const rotaInscriçaoGi = `/enrollment/circuito-fajje-coari-de-jiu-jitsu-coari-am-gi`;
const rotaChecagemGi = "/check/circuito-fajje-coari-de-jiu-jitsu-coari-am-gi/search";
const rotaChecagemNogi = "/check/circuito-fajje-coari-de-jiu-jitsu-coari-am-nogi/search";
const rotaChavesGi = "/tournament/keys/circuito-fajje-coari-de-jiu-jitsu-coari-am-gi"
const rotaChavesNogi = "/tournament/keys/circuito-fajje-coari-de-jiu-jitsu-coari-am-nogi"


const CircuitoFajjeCoariDeJiuJitsuCoariAm: React.FC = () => {
  const { authenticated, getToken } = useAuthenticate();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleToSubscriptionPage = async () => {

    if (!authenticated) {
      Swal.fire({
        title: 'Você precisa estar autenticado',
        text: 'Deseja fazer login para se inscrever no evento?',
        icon: 'info',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Fazer login',
        focusConfirm: false,
        cancelButtonText: 'Agora não'
      }).then((action) => {
        if (action.isConfirmed) navigate('/login')
      });
      return;
    }

    const response = await api.get(
      `/tournaments/info/${slugGI}`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );

    if (response.data.canSubscribe === false) {
      Swal.fire({
        title: 'Atenção!',
        text: 'Período de inscrição encerrado!',
        icon: 'error',
      });
      toast.error('Período de inscrição encerrado!');
      return;
    }

    navigate(`/enrollment/${slugGI}`)

  }
  return (
    <>
      <NavBar />

      <Container>
        <TournamentContainer
          image={require("../../assets/images/tournaments/circuito-fajje-coari-de-jiu-jitsu-coari-am/circuito-fajje-coari-de-jiu-jitsu-coari-am-banner.jpeg")}
        >
          <TournamentContainerBanner>
            <TournamentBanner
              image={require("../../assets/images/tournaments/circuito-fajje-coari-de-jiu-jitsu-coari-am/circuito-fajje-coari-de-jiu-jitsu-coari-am-banner.jpeg")}
              imageMobile={require("../../assets/images/tournaments/circuito-fajje-coari-de-jiu-jitsu-coari-am/circuito-fajje-coari-de-jiu-jitsu-coari-am-mobile.jpeg")}
            />
          </TournamentContainerBanner>
        </TournamentContainer>
        <TournamentContent>
          <Content>
            <Title>{tituloEvento}</Title>
            <Location>
              <Span>Data: {dataEvento}</Span>
              <Span>Início: {horaEvento}</Span>
              <Span>Local: {localEvento}</Span>
              <Span>Endereço: {endereçoEvento}</Span>
              <Span>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                  <FaMapMarkerAlt style={{ marginRight: '8px', color: "red" }} />
                  <a
                    target={"blank"}
                    style={{ color: "#000", textDecoration: "none", fontWeight: "bold" }}
                    href="https://maps.app.goo.gl/SBxD3i4Y7GENwEDz5"
                  >
                    Ver no Google Maps
                  </a>
                </div>
              </Span>
            </Location>
            <P></P>
            <br />

          </Content>
        </TournamentContent>
        <TournamentDescription>
          <TournamentActions>
            <Content>
              {/* <h1 style={{ textAlign: "center" }}>PATROCINADORES</h1>
              <SponsorContainer>
                <SponsorList>
                  {sponsors && sponsors.map((buttons: any, index: number) => (
                    <SponsorButton
                      key={index}
                      img={buttons.img}
                      url={buttons.url}
                      hasError={false}
                      error="Este campo é obrigatório"
                      target="_blank"
                    />
                  ))}
                </SponsorList>
              </SponsorContainer> */}
              <h1 style={{ textAlign: "center" }}>APOIO</h1>
              <SponsorContainer>
                <SponsorList>
                  {support &&
                    support.map((buttons: any) => (
                      <SponsorButton
                        img={buttons.img}
                        url={buttons.url}
                        hasError={false}
                        error="Este campo é obrigatório"
                      />
                    ))}
                </SponsorList>
              </SponsorContainer>
            </Content>

            <Content style={{
              marginTop: '32px'
            }}>

              <EditalContainer>
                <EditalTitle>EDITAL {tituloEvento.toLocaleUpperCase()}</EditalTitle>
                <EditalContent>
                  <Span>
                    O {tituloEvento} é um evento organizado pela FAJJE (Federação Amazonense de Jiu-Jitsu Esportivo) na cidade de Coari/AM, que
                    fomenta e incentiva a prática do jiu jitsu no interior do estado do Amazonas. As lutas
                    serão GI (com kimono) e NOGI (sem kimono), o evento disponibilizará
                    categorias para todas as idades e faixas, conforme as tabelas de peso
                    deste edital. Os competidores terão a oportunidade de testar suas
                    habilidades em um ambiente controlado e com acompanhamento de
                    profissionais qualificados.
                  </Span>
                  <br />
                  <H3>Público alvo:</H3>
                  <P>Todas as academias e atletas de Jiu Jitsu GI e NO GI.</P>
                  <br />
                </EditalContent>

                <Collapse title="PROTOCOLO DE SEGURANÇA CONTRA COVID-19">
                  <P>
                    Devido a dinâmica da situação atual, estamos avaliando diariamente as
                    recomendações dos Órgãos de Saúde e este protocolo pode ser atualizado a
                    qualquer momento caso novas determinações sejam publicadas.
                  </P>
                  <P>
                    Caso o evento seja cancelado por força maior, todas as inscrições serão
                    automaticamente reembolsadas.
                  </P>
                  <P>
                    A organização não é responsável pelos demais custos dos participantes,
                    tais como transporte e hospedagem.
                  </P>
                  <P>
                    Diretrizes do ginásio: Para a segurança de todos, por favor verifique
                    sua temperatura antes de se dirigir ao evento.{" "}
                  </P>
                  <P>Caso haja qualquer sintoma, procure um médico.</P>{" "}
                  <P>
                    {" "}
                    Caso você se sinta indisposto ou esteve em contato com um paciente
                    diagnosticado com Covid-19, por favor fique em casa e procure seu
                    médico.
                  </P>
                  {/* <P>
                  Todo nosso material será desinfetado antes e durante o evento.
                </P> */}
                </Collapse>
                <Collapse title="PREMIAÇÕES 💰🥇" >

                  <H3>Premiação por Academia (Troféus e Dinheiro):</H3>
                  <P>Troféus e Premiação em Dinheiro para as 05 academias.</P>
                  <P>1° lugar: R$2.000,00💰</P>
                  <P>2° lugar: R$1.500,00💰</P>
                  <P>3° lugar: R$1.000,00💰</P>
                  <P>4° lugar: R$500,00💰</P>
                  <P>5° lugar: R$300,00💰</P>

                  <br />
                  <H3>Atletas:</H3>
                  <P>1° lugar: Medalha personalizada do evento🥇</P>
                  <P>2° lugar: Medalha personalizada do evento🥈</P>
                  <P>3° lugar: Medalha personalizada do evento🥉</P>

                  <br />
                </Collapse>

                <Collapse title="INSCRIÇÕES">
                  <Span>
                    As inscrições para o evento serão realizadas exclusivamente online, por
                    meio do site www.torneiofacil.com.br
                  </Span>
                  <P>
                    Durante o processo de inscrição, o atleta ou seu responsável legal
                    deverá selecionar corretamente a categoria referente idade que o atleta
                    completará no ano de 2026, bem como sua faixa e peso.
                  </P>
                  <P>
                    A idade de competição do atleta é a idade máxima que ele terá em 2026,
                    conforme regra da CBJJE.
                  </P>
                  {/* <P>
                    As 200 primeiras inscrições terão uma camiseta grátis!
                  </P> */}
                  <br />
                  <H3>Prazo de Inscrição</H3>
                  <P>
                    O prazo final para inscrições e pagamento será até  {dataDeEncerramentoIncricao}, às {""}
                    {horaDeEncerramentoIncricao}min.
                  </P>
                  <br />
                  <P>As inscrições que não forem pagas serão canceladas.</P>
                  <br />
                  {/* <H3>Valor  </H3>
                  <P>Primeiro Lote até {dataDeEncerramentoInscricaoLote1}</P>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote1} (quarenta reais)</P>
                  <P>Inscrição absoluto R$ {valorinscricaoCategoriaAbsoluto} (trinta reais)</P>
                  <br />
                  <P>Segundo Lote até {dataDeEncerramentoInscricaoLote2}</P>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote2} (cinquenta reais)</P>
                  <P>Inscrição absoluto R$ {valorinscricaoCategoriaAbsoluto} (trinta reais)</P>
                  <P>Inscrição Combo categoria + absoluto R$ {valorinscricaoLote2ComboGieAbsoluto} (setenta reais)</P>

                  <br />
                  <P>Terceiro Lote até {dataDeEncerramentoInscricaoLote3}</P>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote3} (cinquenta reais)</P>
                  <P>Inscrição absoluto R$ { valorinscricaoCategoriaAbsolutoLote3} (quarenta reais)</P>
                  <P>Inscrição Combo categoria + absoluto R$ {valorinscricaoLote3ComboGieAbsoluto} (cem reais)</P>
                  <br /> */}

                  <H3>Correção</H3>
                  <P>
                    A correção da inscrição poderá ser realizada somente após a confirmação
                    do pagamento.
                  </P>
                  <P>
                    Em caso de inscrição equivocada, o atleta ou professor responsável
                    poderá corrigir as informações no site www.torneiofacil.com.br,
                    acessando a opção Meu Perfil em seguida Minhas Inscrições.
                  </P>
                  <P>
                    A correção da inscrição ficará disponível até o encerramento das
                    inscrições {dataDeEncerramentoCorrecao} às {horaDeEncerramentoCorrecao}.
                  </P>
                  <P>
                    Após prazo para correção das inscrições, não serão aceitas modificações
                    nas inscrições.
                  </P>
                  <P>
                    Os atletas que se inscreverem incorretamente estarão sujeitos a
                    desclassificação <b>sem direito a reembolso.</b>
                  </P>
                  <br />
                  <H3>Prazo de Correção</H3>
                  <P>
                    A correção da inscrição fica disponível após a confirmação do pagamento
                    da mesma.
                  </P>
                  <P>
                    A correção da inscrição ficará disponível até {dataDeEncerramentoCorrecao} as {horaDeEncerramentoCorrecao}.
                  </P>
                  <br />
                  <H3>Chaves</H3>
                  <P>
                    O sorteio e divulgação das chaves de lutas será em {dataDeDivulgacaoChaves} até às {horaDeDivulgacaoChaves}.
                  </P>
                  <br />
                  <H3>Inscrição de Absoluto</H3>
                  <P>
                    A inscrição do absoluto será realizada no dia do evento, não será feita pelo sistema.
                  </P>
                </Collapse>
                <Collapse title="MEDALHAS 🥇🥈🥉">
                  <img src={medalhas} alt="Medalhas do evento" style={{ width: '100%', borderRadius: '8px' }} />
                </Collapse>
                <Collapse title="PESSOAS COM DEFICIÊNCIA (PCD)">
                  <H3>
                    As pessoas com deficiência (PCD) devem informar, no momento da
                    inscrição, sua condição pelo WhatsApp. Caso contrário o atleta será
                    desclassificado sem direito a reembolso.
                  </H3>

                  <br />
                </Collapse>

                <Collapse title="VALOR DA INSCRIÇÃO">
                  <Span>
                    Valor único (sem lote de desconto):
                  </Span>
                  <P>Inscrição categoria GI: R$ {valorInscricaoGi}</P>
                  <P>Inscrição categoria NO GI: R$ {valorInscricaoNogi}</P>
                  <br />
                  <P>Pagamento até {dataDeEncerramentoIncricao}.</P>
                  <br />
                  <H3>A inscrição do absoluto será realizada no dia do evento.</H3>
                  <br />
                </Collapse>

                <Collapse title="PAGAMENTO">
                  <H3>
                    A baixa do pagamento será efetuada de forma automática.
                  </H3>
                  <H3>
                    É necessário completar todas as etapas até finalizar a operação de pagamento.
                  </H3>
                  {/* <QRCodeImg src={qrCodecopaAmizadeDeJiuJitsu2024} alt="qrCode" width={300} />
                  <P>
                    <a
                      target={"blank"}
                      style={{ color: "white" }}
                      href="https://whatsa.me/5592981291027/?t=Ol%C3%A1+Thiago_Dellarmelina%2C+vou+enviar+o+comprovante+de+pagamento+referente+a+inscri%C3%A7%C3%A3o+na+%2ACOPA+ORLEY+LOBATO+DE+JIU+JITSU+2024%2A"
                    >
                      <strong>WhatsApp: +55 (92) 98129-1027 </strong>
                      <FaWhatsapp />
                    </a>
                  </P> */}
                  <p />
                  {/* <QRCodeImg src={qrCodeCopaParana} alt="qrCode" width={300} /> */}
                </Collapse>

                <Collapse title="REEMBOLSO DAS INSCRIÇÕES">
                  <H3>
                    Uma vez PAGA a inscrição, o atleta tem direito ao reembolso nas seguintes situações:
                  </H3>
                  <P>
                    1) Quando o evento é CANCELADO.
                  </P>
                  <P>
                    2) Quando ocorre alteração na DATA do evento.
                  </P>
                  <P>
                    3) Quando altera o LOCAL do evento com distância maior que 20km em relação ao anterior.
                  </P>
                  <P>
                    4) Quando há diminuição da premiação, somente para os atletas impactados.
                  </P>
                  <H3>
                    Obs: Para os 4 casos acima, o prazo máximo para solicitar reembolso será de até 5 dias (corridos)
                    após a divulgação do COMUNICADO no site www.torneiofacil.com.br ou DATA FIM da CHECAGEM GERAL ABERTA ( a data que ocorrer primeiro ).
                  </H3>
                  <P>
                    5) Quando o atleta se lesiona e tenha comprado a GARANTIA CAMPEÃ no ato da inscrição (desde que apresente um laudo médico
                    comprovando a lesão até SEGUNDA-FEIRA antecedente ao evento, através do Fale Conosco). Neste caso da garantia, o atleta
                    usufrui do reembolso de 80% do valor pago na inscrição.
                  </P>
                  <P>
                    Em caso de CALAMIDADE PÚBLICA, PANDEMIA, CATÁSTROFE NATURAL e DECRETOS GOVERNAMENTAIS, considerados motivo de FORÇA MAIOR,
                    o atleta NÃO TEM direito ao reembolso.
                  </P>
                  <P>
                    Para estes casos, a organização oferecerá alternativas para uso do crédito do atleta que não puder comparecer na nova data
                    do evento, ao invés do reembolso, desde que o atleta nos notifique pelo FALE CONOSCO até SEGUNDA-FEIRA antecedente ao evento).
                  </P>
                  <P>
                    Após os períodos predeterminados, o atleta perderá o direito a reembolso ou crédito.
                  </P>
                  <H3>
                    Além disso, o atleta NÃO tem direito a reembolso de valores quando:
                  </H3>
                  <P>
                    1) Está sozinho na chave de luta.
                  </P>
                  <P>
                    2) Se machuca antes do evento impossibilitando o atleta de participar do mesmo, sem ter adquirido a GARANTIA CAMPEÃ.
                  </P>
                  <P>
                    3) Desistência por qualquer motivo.
                  </P>
                  {/* <H3>
                      Em caso de Lesão ou doença , o atleta poderá solicitar o reembolso da
                      inscrição, sendo obrigatório a comprovação e apresentação de atestado
                      médico.
                    </H3>
                    <H3>
                      Após o fim do período de inscrição não será possível o reembolso das
                      inscrições pagas.
                    </H3> */}
                </Collapse>

                <Collapse title="REGRAS">
                  <Span>
                    Todas as regras para o evento estão devidamente estipuladas e
                    detalhadas neste edital.
                  </Span>
                  <Span>
                    Em casos de omissão de regras no presente edital, as normas a serem
                    observadas serão aquelas estabelecidas pela Confederação Brasileira de
                    Jiu-Jitsu Esportivo (CBJJE), em conformidade com as diretrizes da
                    CBJJE.
                  </Span>
                  <Span>
                    A tabela de peso por categoria, que estabelece os limites de peso para
                    cada categoria, encontra-se disponível no site oficial do evento,
                    acessível por meio do botão denominado "Tabela de Peso".
                  </Span>
                  <Span>
                    As lutas serão nas categorias GI (com kimonos de cores Oficiais pela
                    cbjje branco, azul e preto ) os kimonos devem estar limpos sem rasgos
                    e sem odor .
                  </Span>
                  <Span>
                    As lutas que serão NO GI (sem kimonos ) , devem ser com vestimentas
                    adequadas , estar limpos sem rasgos e sem odor .
                  </Span>
                  <Span>
                    Haverá premiação em DINHEIRO para o primeiro, segundo, terceiro, quarto e quinto lugar
                    para as academias.
                  </Span>
                  <Span>
                    A pesagem será realizada no dia do evento. O competidor deverá
                    apresentar documento oficial com foto no momento da pesagem.
                  </Span>
                  <Span>
                    A pesagem dos atletas serão realizadas antes do inicio da categoria.
                  </Span>
                  <Span>
                    Atletas que ultrapassarem o limite de peso da categoria que estiverem
                    inscritos serão automaticamente desclassificados.
                  </Span>
                  <Span>Será realizada apenas uma pesagem oficial por atleta.</Span>
                  <Span>Teremos uma balança para pesagem oficial dos atletas.</Span>
                  <Span>
                    Atletas que lutaram em outros eventos com faixa superior não poderão
                    lutar com a faixa abaixo. Se descoberto, o competidor será eliminado
                    do torneio sem direito a reembolso.
                  </Span>
                  <br />
                  <P>
                    <a
                      target={"blank"}
                      href="https://www.cbjje.com.br/assets/regras/regras-cbjje-portugues-2024-06.pdf"
                      style={{ color: "white" }}
                    >
                      <strong>LIVRO DE REGRAS DA CBJJE</strong>
                    </a>
                  </P>
                </Collapse>
                <Collapse title={"CRONOGRAMA" + dataDeDivulgacaoCronograma + " " + horaDeDivulgacaoCCronograma}>
                {/* (EM BREVE) */}
         
                  <Container>
                   
                    <h5>10:00h - 04/05, 06/07, 08/09, 10/11, 12/13, 14/15 (GI - KIMONO)</h5>
                    <h5>10:30h - JUVENIL 16/17 (GI - KIMONO)</h5>
                    <h5>11:00h - ADULTO BRANCA, AZUL, ROXA, MARROM e PRETA (GI - KIMONO)</h5>
                    <h5>11:15h - Início NO GI SEM KIMONO – 04/05, 06/07, 08/09, 10/11, 12/13 (NO GI)</h5>
                    <h5>11:30h - 14/15 (NO GI)</h5>
                    <h5>12:30h - 16/17 (NO GI)</h5>
                        
                    <h5>13:30h - BRANCA (NO GI)</h5>
                    <h5>14:00h - AZUL (NO GI)</h5>
                    <h5>14:30h - ROXA, MARROM e PRETA (NO GI)</h5>
                    <h3>15:00h - ABSOLUTOS</h3>
                    <p><strong>ATENÇÃO</strong></p>
                    <ul>
                    <li>Os atletas devem chegar no evento 1h antes da sua Categoria de Idade.</li>
                    <li>Não há tolerância de peso.</li>
                    <li>Todos os atletas devem apresentar documento oficial na hora da luta.</li>
                    </ul>

                  
                  </Container>
                </Collapse>
                <Collapse title="ENTRADA">
                  <P>
                    Liberada ao público.
                  </P>
                  {/* <br />
                <P>Crianças até 5 anos ficam isentas de qualquer tipo de pagamento.</P>
                <br /> */}
                </Collapse>
                <Collapse title="CONTATO">
                  <P>Caso Precise falar com o responsável do evento, entre em contato por telefone ou WhatsApp.</P>
                  <a target={"blank"} href="https://whatsa.me/5592994663061/?t=Ol%C3%A1,%20Luis%20Neto!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20no%20*CIRCUITO%20FAJJE%20COARI%20-%20GI%20%26%20NO%20GI%202026*"
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsApp} </strong>
                    <FaWhatsapp />
                  </a>
                  <br />
                  <br />
                  <P>
                    Dúvidas sobre cadastro, inscrição, pagamento, correção, checagem ou
                    sugestão de melhorias entre em contato com a equipe do Torneio Fácil
                    por telefone ou WhatsApp.
                  </P>
                  <P>Melhor horário para atendimento das 18:00h as 23:59h.</P>
                  <a
                    target={"blank"}
                    href="https://whatsa.me/5511944563515/?t=Ol%C3%A1%20Equipe%20Torneio%20F%C3%A1cil!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20no%20*CIRCUITO%20FAJJE%20COARI%20-%20GI%20%26%20NO%20GI%202026*"
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsAppTorneio} </strong>
                    <FaWhatsapp />
                  </a>

                  <br />
                </Collapse>
              </EditalContainer>
            </Content>
            <br />
            <Content>
              <TournamentEnrollmentLinkEndpage to={""} onClick={() => handleToSubscriptionPage()}>
                {/* <TournamentEnrollmentLinkEndpage to="#"> */}
                Inscrição
              </TournamentEnrollmentLinkEndpage>

              <TournamentEnrollmentLinkEndpage to="/profile/subscription">
                Correção da Inscrição
              </TournamentEnrollmentLinkEndpage>
              {/* <TournamentLink href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.767B171E&u=teste" target="_blank">Chaves</TournamentLink> */}
              {/* // /check/16-COPA-PARANA-DE-JIU-JITSU */}

              <TournamentLink
                // target="_blank"
                href={rotaChecagemGi}
              >
                Checagem GI
              </TournamentLink>
              <TournamentLink
                // target="_blank"
                href={rotaChecagemNogi}
              >
                Checagem NOGI
              </TournamentLink>

              {/* <TournamentLink
                // target="_blank"
                href={rotaChecagemNoGi}
              >
                Checagem NOGI
              </TournamentLink> */}

              {/* 
              <TournamentLink
                href="/check/toledo-international-open-brazilian-jiu-jitsu-nogi-2023-ginasio-de-esportes-alcides-pan-toledo-pr/search"
                target="_blank"
              >
                Checagem de atletas NO GI
              </TournamentLink>  */}

              <TournamentLink
                // target="_blank"
                href={rotaChavesGi}
              >
                Chaves GI
              </TournamentLink>
              <TournamentLink
                // target="_blank"
                href={rotaChavesNogi}
              >
                Chaves NOGI
              </TournamentLink>


              {/*               <TournamentLink
                href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.5B5B1C9A&u=teste"
                target="_blank"
              >
                Chaves NO GI
              </TournamentLink> */}

              <TournamentLink target="blank" href={tabelaPeso}>
                Tabela de pesos
              </TournamentLink>
              {/* <TournamentLink href="#">Resultados (EM BREVE)</TournamentLink> */}
            </Content>
          </TournamentActions>
        </TournamentDescription>
      </Container>
      <Footer />
    </>
  );
};

export default CircuitoFajjeCoariDeJiuJitsuCoariAm;
